import request from './common/request'
import { MERCHANT_REPORT_BI_URL } from './urls'

/**
 * 数据报表 - 获取省份报名汇总
 */
export async function provinceSummary(query) {
  return request({
    url: `${MERCHANT_REPORT_BI_URL}/provinceSummary`,
    method: 'GET',
    params: query
  })
}

/**
 * 数据报表 - 获取报名汇总
 */
export async function summary(query) {
  return request({
    url: `${MERCHANT_REPORT_BI_URL}/summary`,
    method: 'GET',
    params: query
  })
}

/**
 * 数据报表 - 获取日期报名趋势汇总
 */
export async function timeTrendSummary(query) {
  return request({
    url: `${MERCHANT_REPORT_BI_URL}/timeTrendSummary`,
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/merchant-report-bi.js